import { render, staticRenderFns } from "./SupplierContact.vue?vue&type=template&id=5cb3244e&"
import script from "./SupplierContact.vue?vue&type=script&lang=js&"
export * from "./SupplierContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports